module.exports = __webpack_public_path__ + "static/product-l0810-c064c222c03bd6717fe334938230280f.png";